import Swal from 'sweetalert2';
import Vue from 'vue';

class AlertHelper {
  // Configuração padrão
  static defaultConfig = {
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    buttonsStyling: true,
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-danger'
    }
  };

  // Alert básico
  static async alert(title, text = '', icon = 'info') {
    return Swal.fire({
      ...this.defaultConfig,
      title,
      text,
      icon,
      confirmButtonText: 'OK'
    });
  }

  // Success
  static async success(title, text = '') {
    return this.alert(title, text, 'success');
  }

  // Error
  static async error(title, text = '') {
    return this.alert(title, text, 'error');
  }

  // Warning
  static async warning(title, text = '') {
    return this.alert(title, text, 'warning');
  }

  // Info
  static async info(title, text = '') {
    return this.alert(title, text, 'info');
  }

  // Question
  static async question(title, text = '') {
    return this.alert(title, text, 'question');
  }

  // Confirmação
  static async confirm(title, text = '', confirmButtonText = 'Sim', cancelButtonText = 'Cancelar') {
    return Swal.fire({
      ...this.defaultConfig,
      title,
      text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      reverseButtons: true
    });
  }

  // Input
  static async input(title, inputType = 'text', inputValue = '', inputOptions = {}) {
    return Swal.fire({
      ...this.defaultConfig,
      title,
      input: inputType,
      inputValue,
      inputAttributes: inputOptions,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      preConfirm: (value) => {
        if (!value) {
          Swal.showValidationMessage('Este campo é obrigatório');
        }
        return value;
      }
    });
  }

  // Toast (notificação rápida)
  static toast(title, icon = 'success', position = 'top-end', timer = 3000) {
    const Toast = Swal.mixin({
      toast: true,
      position,
      showConfirmButton: false,
      timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });

    Toast.fire({
      icon,
      html: title
    });
  }

  // Loading
  static loading(title = 'Carregando...') {
    Swal.fire({
      title,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

  // Close loading/alert
  static close() {
    Swal.close();
  }

  // Customizado
  static custom(config) {
    return Swal.fire({
      ...this.defaultConfig,
      ...config
    });
  }

  // Delete confirmation (específico para exclusões)
  static async deleteConfirm(title = 'Tem certeza?', text = 'Esta ação não pode ser desfeita!') {
    return this.confirm(
      title,
      text,
      'Sim, excluir!',
      'Cancelar'
    );
  }

  // Success with auto close
  static async successAutoClose(title, text = '', timer = 2000) {
    return Swal.fire({
      ...this.defaultConfig,
      title,
      text,
      icon: 'success',
      showConfirmButton: false,
      timer
    });
  }
}
Vue.prototype.AlertHelper = AlertHelper;
window.AlertHelper = AlertHelper;
export default AlertHelper;